import React, { useState } from "react";
import ReportsDateSelect from "../../../commons/ReportsDateSelect/ReportsDateSelect";
import "../index.scss";
import { DropDown } from "../../../commons";
import { BranchListType } from "../../../../screens/Reports/ProfitLoss";
import { WarningIcon } from "../../../../assets/images";

type AppProps = {
  date: any;
  handleDateChange: (data: any) => void;
  handleSubmitData?: () => void;
  toggle: boolean;
  isDownloadDetailedBalanceSheetPresent: boolean;
  detailedBalanceSheetData: any;
  setToggle: (data: boolean) => void;
  handleDownloadDetailedBalanceSheetReport: () => void;
  branchList: any;
  handleBranchChange: (data: BranchListType) => void;
  branchSelected: any;
};

const DetailedBalanceSheetHeader = ({
  date,
  handleDateChange,
  handleSubmitData,
  toggle,
  setToggle,
  handleDownloadDetailedBalanceSheetReport,
  detailedBalanceSheetData,
  isDownloadDetailedBalanceSheetPresent,
  branchList,
  branchSelected,
  handleBranchChange,
}: AppProps) => {
  return (
    <>
      {/* <div className="grouping-headers mt-3">Detailed Balance Sheet</div> */}
      <div
        className="d-flex justify-content-start align-items-center p-1 mb-3 mt-3"
        style={{
          backgroundColor: "#fff5e5",
          border: "1px solid #be7e12",
          width: "75%",
          borderRadius: "6px",
        }}
      >
        <img src={WarningIcon} alt="warning" />
        <span style={{ color: "#be7e12" }} className="ml-2">
          Assets & Liabilities balances might be mismatched if you see branch
          wise Balance Sheet with stock entries.
        </span>
      </div>
      <div
        className="d-flex position-relative justify-content-start align-items-center mt-3"
        style={{ gap: "0.7rem" }}
      >
        <div className="form-group">
          <label className="mb-1">Date</label>
          <div>
            <ReportsDateSelect
              type={"balanceSheet"}
              setToggle={setToggle}
              toggle={toggle}
              startDate={date}
              endDate={date}
              handleStartDateChange={handleDateChange}
              handleEndDateChange={handleDateChange}
            />
          </div>
        </div>
        <div className="form-group ml-4 mr-4" style={{ width: "15%" }}>
          <label className="mb-1">Branch</label>
          <DropDown
            options={
              branchList
                ? [{ value: "", label: "Select Branch..." }, ...branchList]
                : [{ value: "", label: "Select Branch..." }]
            }
            value={branchSelected}
            handleChange={handleBranchChange}
          />
        </div>
        <div className="mt-2">
          <button
            className="btn btn-primary"
            onClick={handleSubmitData}
            disabled={!date?.length}
          >
            Get Statement
          </button>
        </div>
      </div>
    </>
  );
};

export default DetailedBalanceSheetHeader;
